export default __webpack_public_path__ + "static/media/Home-foto-header-sports-Tower-viajes-mobile@3x.941a7556.jpg";